const profileForm = document.querySelector('#account-profile form')

if (profileForm) {
  // autosubmit on profile photo change
  const fileInput = profileForm.querySelector('input[type=file]')
  fileInput.addEventListener('change', () => {
    profileForm.submit()
  })
}
